import React, { useEffect, useState } from "react";
import PageWrapper from "../SignupPages/PageWrapper";
import congratsIcon from "../../assets/images/congratsSvgIcon.png";
import questionIcon from "../../assets/images/questionSvgIcon.png";
import tickIcon from "../../assets/images/tickSvgIcon.png";
import contactIcon from "../../assets/images/contactSvgIcon.png";
import "../SignupPages/SignupCommon.css";
import "../SignupPages/Signup6.css";
import "./CheckoutSignupPages.css";
import { useLocation, useNavigate } from "react-router-dom";

const CheckoutSignupPage3: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
      const success = JSON.parse(localStorage.getItem("success_transaction") || "{}")?.value;
    
      if (success === true) {
        if (!window.history.state || !window.history.state.trapped) {
          window.history.pushState({ trapped: true }, "", window.location.href);
        }
    
        let backPressCount = 0;
        const handleBack = (event: PopStateEvent) => {
          backPressCount++;
          if (backPressCount === 1) {
            if (!window.history.state || !window.history.state.trapped) {
              window.history.pushState({ trapped: true }, "", window.location.href);
            }
            setShowPopup(true);
          } else {
            navigate("/glp1/checkout");
          }
        };
    
        window.addEventListener("popstate", handleBack);
        return () => window.removeEventListener("popstate", handleBack);
      }
    }, [navigate]);
    
    
    const handleProceed = () => {
      // clear steps and go to homepage
      // const keysToRemove = [
      //   "step-1-completed", "step-2-completed", "step-3-completed",
      //   "step-4-completed", "step-5-completed", "step-6-completed",
      //   "step-6b-completed", "step-7-completed", "step-8-completed",
      //   "step-9-completed", "step-10-completed", "step-11-completed",
      //   "step-12-completed", "step-13-completed", "step-13b-completed",
      //   "step-14-completed", "step-15-completed"
      // ];
  
      // keysToRemove.forEach(key => localStorage.removeItem(key));
      navigate("/glp1/thank-you", { replace: true });
      setShowPopup(false);
    };
  
    const styles: {
      overlay: React.CSSProperties;
      headerStyle: React.CSSProperties;
      modal: React.CSSProperties;
      modalHeader: React.CSSProperties;
      iconButton: React.CSSProperties;
      buttonPrimary: React.CSSProperties;
    } = {
      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        paddingTop:"150px",
        zIndex: 9999,
      },
      headerStyle:{
        color: "#0c3972",
        marginBottom: "16px"
      },
      modal: {
        backgroundColor: "#fff",
        borderRadius: "12px",
        padding: "30px",
        width: "90%",
        maxWidth: "600px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
        textAlign: "center",
      },
      modalHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      },
      iconButton: {
        fontSize: "20px",
        fontWeight: "bold",
        cursor: "pointer",
        padding: "4px 10px",
        borderRadius: "50%",
        transition: "background 0.2s",
        userSelect: "none",
        color: "rgb(192, 192, 192)",
      },
      buttonPrimary: {
        backgroundColor: "#0C3972",
        color: "#fff",
        border: "none",
        padding: "10px 20px",
        borderRadius: "30px",
        cursor: "pointer",
        width:"100%",
        fontSize:"14px"
      },
    };

  // ✅ Prevent duplicate navigate push
  const safeNavigate = (path: string) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  useEffect(() => {
    const success = JSON.parse(localStorage.getItem("success_transaction") || "{}")?.value;
    if (success) {
      safeNavigate("/glp1/thank-you");
    }else{
      safeNavigate("/glp1/checkout");
    }
  }, [location.pathname]);

  const handleNext = () => {
    safeNavigate("/glp1/getting-started/step-1");
  };

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <div className="signup-content">
          <div
            className="checkout-signup-header"  
          >
            <img src={congratsIcon} alt="congrats" width={26} height={26} />
            <p>Congratulations on completing your order!</p>
          </div>
          <div className="signup-content-context-box">
            <img src={tickIcon} alt="tickIcon" width={26} height={26} />
            <p>You are just a few steps away from receiving your GLP-1s</p>
          </div>

          <div className="signup-content-context-box">
            <img src={questionIcon} alt="questionIcon" width={26} height={26} />
            <p>
              Proceed and <b>answer a few quick questions.</b>
            </p>
          </div>

          <div className="signup-content-context-box">
            <img
              src={contactIcon}
              style={{ marginTop: "5px" }}
              alt="contactIcon"
              width={26}
              height={26}
            />
            <p>
              Our GLP-1 specialist will connect with you after you complete the
              online process.
            </p>
          </div>
        </div>

        <button className="next-btn sticky-btn" onClick={handleNext}>
          PROCEED →
        </button>
      </div>
      {showPopup && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
          <div style={styles.modalHeader}>
      </div>
            <h2 style={styles.headerStyle}>Wait! You are not done yet.</h2>
            <p style={{fontWeight: "400", fontSize: "16px", lineHeight: "20px",fontStyle: "normal"}}>Please complete the form and proceed to the next step. If you go back, you might have to redo the entire process again.</p>
            <div style={{ marginTop: "24px", display: "flex", gap: "12px", justifyContent: "center" }}>
            
              <button onClick={handleProceed} style={styles.buttonPrimary}>PROCEED</button>
              
            </div>
          </div>
        </div>
      )}
    </PageWrapper>
  );
};

export default CheckoutSignupPage3;
